import React from "react";
import { Link } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";

export default function PremiumGate({ title = "Unlock with Premium", body = "Upgrade to message caregivers, request bookings, save favorites, and get AI-powered matching.", cta = "See Premium — $9.99/mo" }) {
  return (
    <div className="card-organic p-8 md:p-10 relative overflow-hidden" data-testid="premium-gate">
      <div className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-gold/20 blur-2xl" />
      <div className="relative flex flex-col md:flex-row items-start gap-5">
        <div className="w-12 h-12 rounded-full bg-gold/20 flex items-center justify-center border border-gold/40">
          <Sparkles className="w-6 h-6 text-gold" />
        </div>
        <div className="flex-1">
          <h3 className="font-serif text-2xl text-forest">{title}</h3>
          <p className="text-forest/75 mt-2 leading-relaxed">{body}</p>
          <Link to="/pricing" className="btn-primary inline-flex items-center gap-2 mt-5" data-testid="gate-cta">
            <Lock className="w-4 h-4" /> {cta}
          </Link>
        </div>
      </div>
    </div>
  );
}
